import { format } from "date-fns";
import formatPartCode from "helper/formatPartCode";
/* 
    This file contains any function that are used in multiple components
    of the inventory management section 
 */
export const formatLocation = (e, locationDetails) => {
    if (locationDetails) {
        const { locationType } = locationDetails || {};
        const lane = locationDetails?.lane || "";
        const rack = locationDetails?.rack || "";
        const room = locationDetails?.room || "";
        const shelf = e?.shelf || "";
        const drawer = e?.drawer || "";

        switch (locationType) {
            case "Lane/Rack/Shelf":
                return `${lane}${rack}${shelf}`;
            case "Lane/Rack/Shelf/Drawer":
                return `${lane}${rack}${shelf}${drawer ? `${drawer}` : ""}`;
            case "Room":
                return `${room}`;
            case "Room/Rack/Shelf":
                return `${room}${rack}${shelf}`;
            case "Room/Rack/Shelf/Drawer":
                return `${room}${rack}${shelf}${drawer ? `${drawer}` : ""}`;
            default:
                // Fallback: concatenate what exists in a sensible order
                return `${lane || room || ""}${rack}${shelf}${drawer ? `${drawer}` : ""}`;
        }
    } else {
        if (e.drawer) {
            return e.location + e.rack + e.shelf + "D" + e.drawer;
        } else {
            return e.location + e.rack + e.shelf;
        }
    }

}

export const formatIdentifier = (item) => {
    const padZero = formatPartCode(item);
    if (item.refurbished) {
        return padZero + "R";
    }
    return padZero;
}
